/**
 * Tokens de design — única fonte de verdade. Nenhum outro arquivo deve
 * hardcodar hex/px; sempre referenciar daqui (via CSS custom properties
 * ou import direto em TS quando o valor precisa ir pro MapLibre).
 */

export const color = {
  bgBase: '#0A0D10',
  bgPanel: '#12171C',
  borderHairline: 'rgba(255,255,255,0.08)',
  accentLive: '#3FD4FF',
  accentCritical: '#F2A93B',
  textPrimary: '#E7EBEE',
  textSecondary: '#7C8791',
} as const;

export const font = {
  heading: "'Space Grotesk', sans-serif",
  body: "'Inter', sans-serif",
  mono: "'JetBrains Mono', monospace",
} as const;

export const fontWeight = {
  headingMedium: 500,
  headingSemibold: 600,
} as const;

/** Cor de um pixel de "ping" por camada — cada camada tem identidade própria,
 *  mas nenhuma usa o âmbar de alerta (reservado só pra severity: 'critical'). */
export const layerColor: Record<string, string> = {
  flights: '#3FD4FF',
  earthquakes: '#B98CFF',
  'webcams-windy': '#4ADE80',
  'webcams-wsdot': '#4ADE80',
  'webcams-der-sp': '#4ADE80',
  wildfires: '#FF6B4A',
  satellites: '#5B8DEF',
  maritime: '#3FD4FF',
  news: color.textSecondary, // #7C8791 — cor neutra, sem urgência de "ao vivo"
};

/** severity: 'critical' sempre sobrescreve a cor da camada pelo âmbar. */
export function resolveEntityColor(layer: string, severity: 'normal' | 'critical'): string {
  if (severity === 'critical') return color.accentCritical;
  return layerColor[layer] ?? color.accentLive;
}
